import { Dict } from "../../models/interfaces";
import { ListSort } from ".";

export enum ListEntityType {
  Lead = "Lead",
  Activity = "Activity",
  Project = "Project",
  Property='Property',
  TestDriveVehicle = "TestDriveVehicle",
  Enquiry = "Enquiry",
  Customer = "Customer",
  VINRequest = "VINRequest",
  TradeIn = "TradeIn",
  Finance = "Finance",
  ConfigurationToOrderReport = "ConfigurationToOrderReport",
  LeadEnquiry = "LeadEnquiry",
  CashDiscountSummary = "CashDiscountSummary",
  PoolDiscountSummary = "PoolDiscountSummary",
  CancelConfigurationList = "CancelConfigurationList",
  ReportLeadConversionSob = "ReportLeadConversionSob",
  ReportLeadConversionSalesperson = "ReportLeadConversionSalesperson",
  ReportLeadConversionCrmAgent = "ReportLeadConversionCrmAgent",
  ReportLeadConversionCarline = "ReportLeadConversionCarline",
  ReportLeadConversion = "ReportLeadConversion",
  DailySalesReport = "DailySalesReport",
  ActivitySummaryReport = "ActivitySummaryReport",
  CollectionSegregationReport = "CollectionSegregationReport",
  LeadLostReport = "LeadLostReport",
  LeadJourney = "LeadJourney",
  TradeInDiscountSummary = "TradeInDiscountSummary",
  DiscountSummaryReport = "DiscountSummaryReport",
  Configuration = "Configuration",
  PreVIN = "PreVIN",
  Dashboard = "Dashboard",
  ReportLeadConversionIt = "ReportLeadConversionIt",
  MonthEndClosing = "MonthEndClosing",
  CancelInvoiceList = "CancelInvoiceList",
  PreBookingCombinations = "PreBookingCombinations",
  EmailReport = "EmailReport",
  VehicleReport = "VehicleReport",
  Ocr = "Ocr",
  AccessoryReport = "AccessoryReport",
  CouponReport = "CouponReport",
  Calendar = "calendar",
  InsuranceReport = "InsuranceReport",
  ServicePackageReport = "ServicePackageReport",
  SalesReport = "SalesReport",
  WhatsappReport = "WhatsappReport",
  AllRequests = "AllRequests",
  CustomerDataChangeReport = "CustomerDataChangeReport",
  PaymentsPendingAgainstMK = "PaymentsPendingAgainstMK",
  Company = "Company",
  Requirement='Requirement',
  RentOrLease ='RentOrLease',
  Buy ='Buy',
  Developers = 'Developers',
  Companies = 'Companies',
  Proposal = "Proposal",
  ReportDetail = "ReportDetail",
  ReportSiteVisitDetail = "ReportSiteVisitDetail",
  TenancyExpiryTracker = "TenancyExpiryTracker",
  TermSheet = 'TermSheet',
  FeeConfirmation = 'FeeConfirmation',
  LOI = 'LetterOfIntent',
  Agreement = 'Agreement',
  Invoice = 'Invoice',
  Transaction360 = "transaction360",
  SpecialApprovalProposalRequested = 'SpecialApprovalProposalRequested',
  SpecialApprovalProposalRejected = 'SpecialApprovalProposalRejected',
  SpecialApprovalProposalApproved = 'SpecialApprovalProposalApproved',
  SpecialApprovalTermsheetDraft = 'SpecialApprovalTermsheetDraft',
  SpecialApprovalTermsheetInternal = 'SpecialApprovalTermsheetInternal',
  SpecialApprovalTermsheetClient= 'SpecialApprovalTermsheetClient',
  SpecialApprovalTermsheetLandlord = 'SpecialApprovalTermsheetLandlord',
  SpecialApprovalTermsheetSigned = 'SpecialApprovalTermsheetSigned',
  SpecialApprovalTermsheetRejected = 'SpecialApprovalTermsheetRejected',
  SpecialApprovalFeeLetterClientDraft = 'SpecialApprovalFeeLetterClientDraft',
  SpecialApprovalFeeLetterClientInternal = 'SpecialApprovalFeeLetterClientInternal',
  SpecialApprovalFeeLetterClientClientApproval = 'SpecialApprovalFeeLetterClientClientApproval',
  SpecialApprovalFeeLetterClientSigned = 'SpecialApprovalFeeLetterClientSigned',
  SpecialApprovalFeeLetterClientRejected = 'SpecialApprovalFeeLetterClientRejected',
  SpecialApprovalFeeLetterLandlordDraft = 'SpecialApprovalFeeLetterLandlordDraft',
  SpecialApprovalFeeLetterLandlordInternal = 'SpecialApprovalFeeLetterLandlordInternal',
  SpecialApprovalFeeLetterLandlordLandlordApproval = 'SpecialApprovalFeeLetterLandlordLandlordApproval',
  SpecialApprovalFeeLetterLandlordSigned = 'SpecialApprovalFeeLetterLandlordSigned',
  SpecialApprovalFeeLetterLandlordRejected = 'SpecialApprovalFeeLetterLandlordRejected',
  SpecialApprovalLOIDraft = 'SpecialApprovalLOIDraft',
  SpecialApprovalLOIInternal = 'SpecialApprovalLOIInternal',
  SpecialApprovalLOIClient = 'SpecialApprovalLOIClient',
  SpecialApprovalLOILandlord = 'SpecialApprovalLOILandlord',
  SpecialApprovalLOISigned = 'SpecialApprovalLOISigned',
  SpecialApprovalLOIRejected = 'SpecialApprovalLOIRejected',
  SpecialApprovalAgreementDraft = 'SpecialApprovalAgreementDraft',
  SpecialApprovalAgreementInternal = 'SpecialApprovalAgreementInternal',
  SpecialApprovalAgreementClient = 'SpecialApprovalAgreementClient',
  SpecialApprovalAgreementLandlord = 'SpecialApprovalAgreementLandlord',
  SpecialApprovalAgreementSigned = 'SpecialApprovalAgreementSigned',
  SpecialApprovalAgreementRejected = 'SpecialApprovalAgreementRejected',
  SpecialApprovalInvoiceClientWaitingApproval = 'SpecialApprovalInvoiceClientWaitingApproval',
  SpecialApprovalInvoiceClientPaymentPending = 'SpecialApprovalInvoiceClientPaymentPending',
  SpecialApprovalInvoiceClientPaymentCollection = 'SpecialApprovalInvoiceClientPaymentCollection',
  SpecialApprovalInvoiceClientRejected = 'SpecialApprovalInvoiceClientRejected',
  SpecialApprovalInvoiceLandlordWaitingApproval = 'SpecialApprovalInvoiceLandlordWaitingApproval',
  SpecialApprovalInvoiceLandlordPaymentPending = 'SpecialApprovalInvoiceLandlordPaymentPending',
  SpecialApprovalInvoiceLandlordPaymentCollection = 'SpecialApprovalInvoiceLandlordPaymentCollection',
  SpecialApprovalInvoiceLandlordRejected = 'SpecialApprovalInvoiceLandlordRejected',
}

export interface FilterValue<T = any> {
  value: T;
  label: string;
}

export type FilterValueType<T = any> =
  | FilterValue<T>
  | FilterValue<T>[]
  | undefined;

export interface SavedFilter {
  _id: string;
  name: string;
  value: Dict<FilterValueType>;
}

export interface Column {
  key: string;
  order: number;
}

export interface ListColumnSettings {
  columns: Column[];
}
export interface QueryFilter {
  query?: string;
  filters?: Dict<FilterValueType>;
  page?: number;
  perPage?: number;
  view?: string;
  startDate?: Date;
  endDate?: Date;
  sort?: ListSort;
  dateType?: string;
  listView?: string;
}
